import { format } from "date-fns";
import { enUS, es, ptBR } from "date-fns/locale";

const getLocale = (language: string) =>
  language === "pt-BR" ? ptBR : language === "en-US" ? enUS : es;

export const formatExecutionDateTime = (
  value: string | null | undefined,
  language: string,
) => {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return format(date, "Pp", { locale: getLocale(language) }).replaceAll(
    ",",
    "",
  );
};

export const formatExecutionDate = (
  value: string | null | undefined,
  language: string,
) => {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return format(date, "P", { locale: getLocale(language) });
};

export const toApiDate = (date: Date | null | undefined) => {
  if (!date) return undefined;

  const normalizedDate = new Date(date);
  normalizedDate.setHours(15);

  return normalizedDate.toISOString().substring(0, 10);
};
